exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-toolbar {\n    padding: 0 5% 0 5%;\n    position: absolute;\n    top: 0;\n    z-index: 1;\n}\n\n.spacer {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n}\n\n.icon {\n    padding: 0 6px;\n}\n\na {\n    text-decoration: none;\n    letter-spacing: 0.3px;\n    font-size: 16px;\n    font-weight: 400;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/navigation/navigation.component.css
// module id = ../../../../../src/app/navigation/navigation.component.css
// module chunks = main